import Box from "../Box/Box";
import Button from "../Button/Button";
import useBreakpoint from "../../hooks/useBreakpoint";
import Stepper from "../Stepper/Stepper";

type Props = {
  children: React.ReactNode;
  handleClick: () => void;
  imgOpacity: number;
  slideId?: number;
};

const DisplayContentLayout = ({
  children,
  imgOpacity = 0,
  handleClick,
}: Props) => {

  const {isMobile, isDesktop, isTablet, isDesktopSmall, isLandscape, isFourK } = useBreakpoint();

  return (
    <Box
      position="relative"
      maxWidth={isMobile ? '100%' : isTablet || isLandscape ? "85%" : '50%'}
      height={isMobile ? '100%': isTablet || isLandscape ? "60%": isDesktopSmall ? "80%": "70%"}
      opacity={imgOpacity}
      // transition= "all 1s ease-out"
      marginRight={isTablet || isLandscape || isMobile ? 0:  190}
      >
      {<Button
        style={{
          zIndex: 1,
          position: 'absolute',
          right: isMobile ? 30: 0,
          top: isMobile ? '3vh': undefined,
          cursor: "pointer",
        }}
        label=""
        type="backIcon"
        onClick={() => {
          handleClick();
        }}
      />}
 
      {children}
    </Box>
  );
};

export default DisplayContentLayout;
